'use strict';

class Modal extends HTMLElement {
    constructor() {
        super();
        let modalTemplate = document.querySelector('#template-modal');
        const clone = modalTemplate.content.cloneNode(true);
        this.closeBtn = clone.querySelector('.jwsdw-modalBackButton');
        this.blur = clone.querySelector('.jwsdw-modal-body-blur');
        this.modalContainer = clone.querySelector('[part="templateModal"]');
        this._open = false;
        const shadowRoot = this.attachShadow({ 'mode': 'open', 'delegatesFocus': true });
        shadowRoot.appendChild(clone);

        this.classList.add('modal-loaded');
    }

    triggerEvent(event) {
        this.dispatchEvent(new CustomEvent(`modal:${event}`));
    }

    open() {
        if (this._open) {
            return;
        }

        document.body.classList.add('jws-overflowHidden');
        this.triggerEvent('opening');

        this.setAttribute('data-show', 'on');
        this.modalContainer.setAttribute('aria-modal', 'true');
        this.previousActiveElement = document.activeElement;
        this.setAttribute('tabindex', '-1');
        this.focus();

        this._open = true;

        this.modalContainer.addEventListener(
            'transitionend',
            () => {
                this.triggerEvent('open');
                this.focusableElements.shift().focus();
            },
            { 'once': true }
        );
    }

    close() {
        if (!this._open) {
            return;
        }

        document.body.classList.remove('jws-overflowHidden');
        this.triggerEvent('closing');
        this.setAttribute('data-show', 'off');
        this.removeAttribute('tabindex');
        this.modalContainer.setAttribute('aria-modal', 'true');
        this.previousActiveElement && this.previousActiveElement.focus();

        this._open = false;

        this.modalContainer.addEventListener(
            'transitionend',
            this.triggerEvent.bind(this, 'closed'),
            { 'once': true }
        );
    }

    connectedCallback() {
        this.closeBtn.addEventListener('click', () => {
            this.close();
        });
        this.blur.addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                this.close();
            }
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27) {
                this.close();
            }
        }.bind(this));
        this.trapFocus();

        if (this.hasAttribute('data-auto-open')) {
            this.removeAttribute('data-auto-open');
            this.open();
        }

        /* Attach event listener for modal close buttons */
        this.addEventListener('click', this.handleModalCloseButtons);
    }

    get focusableElements() {
        const focusableElementsSelector = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'; // eslint-disable-line max-len
        return [
            ...this.shadowRoot.querySelectorAll(focusableElementsSelector),
            ...this.querySelectorAll(focusableElementsSelector)
        ];
    }

    disconnectedCallback() {
        /* Cleanup */
        this.removeEventListener('click', this.handleModalCloseButtons);
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    trapFocus() {
        let focusableEls = this.focusableElements,
            firstFocusableEl,
            lastFocusableEl,
            isTabPressed;

        firstFocusableEl = focusableEls.shift();
        lastFocusableEl = focusableEls.pop();

        if (!lastFocusableEl) {
            lastFocusableEl = firstFocusableEl;
        }


        this.addEventListener('keydown', function (e) {
            isTabPressed = e.key === 'Tab';

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableEl || this.shadowRoot.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableEl || this.shadowRoot.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    }

    handleModalCloseButtons(e) {
        let closeButton;

        if (e.target.matches(`.${Modal.closeButtonClass}`)) {
            return this.close();
        }

        closeButton = e.target.closest(`.${Modal.closeButtonClass}`);
        if (closeButton) {
            return this.close();
        }
    }
}

Modal.closeButtonClass = 'jwsdw-modalClose-button';

customElements.define('template-modal', Modal);

$('body').on('click', '.jwsdw-modal-button', (e) => {
    const $this = $(e.target),
        targetModal = $this.attr('data-target');

    let $targetModal;

    if (!targetModal) {
        return;
    }

    $targetModal = $(targetModal);

    if ($targetModal.length) {
        $targetModal[0].open(e.target);
    }
});